import './index.scss';

const TypingLetters =({ letterClass, strArray, idx })=> {
    return (
        <h1 id="about">About me</h1>
    )
};

export default TypingLetters
